// Google map

const googleMapsKey = 'AIzaSyCtVLV2yHdQ_4Z79oUXVlN7GkrGNvqnDaQ';
const googleMapConfig = {
    center: { lat: 50.0755, lng: 14.4378 },
    zoom: 14,
}
const defaultGooleMapZoom = 16;

class Map {
    static createMapMarker() {
        var myMap;
        if (gMarkerData.length > 1) {
            var latlngbounds = new google.maps.LatLngBounds();
            gMarkerData.forEach(function (marker) {
                latlngbounds.extend(marker.latLng);
            });
            var mapConfig = {
                center: latlngbounds.getCenter(),
                zoom: defaultGooleMapZoom,
            }
            myMap = new google.maps.Map(gMapElement, mapConfig);
            myMap.fitBounds(latlngbounds);
        } else if (gMarkerData.length > 0) {
            var mapConfig = {
                center: gMarkerData[0].latLng,
                zoom: defaultGooleMapZoom,
            }
            myMap = new google.maps.Map(gMapElement, mapConfig);
        }
        else {
            myMap = new google.maps.Map(gMapElement, googleMapConfig);
        }

        var marketList = [];
        var indexer;
        for (indexer = 0; indexer < gMarkerData.length; indexer++) {
            var infowindow = new google.maps.InfoWindow();
            var marker = new google.maps.Marker({
                position: gMarkerData[indexer].latLng,
                icon: {
                    labelOrigin: new google.maps.Point(16, 48),
                    url: gMarkerData[indexer].pin,
                    scaledSize: new google.maps.Size(32, 32),
                },
                optimized: false,
                title: gMarkerData[indexer].title,
            });
            marker.setMap(myMap);
            google.maps.event.addListener(marker, 'click', (function (marker, markerData, infowindow) {
                return function () {
                    infowindow.setContent(markerData.content);
                    infowindow.open(myMap, marker);
                };
            })(marker, gMarkerData[indexer], infowindow));
            marketList.push(marker);
        }

        return myMap;
    }
}

function initMapClinic() {
    Map.createMapMarker();
}
window.initMapClinic = initMapClinic;

function httpGetAsync(pinUrl, theUrl, callback) {
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.onreadystatechange = function () {
        if (xmlHttp.readyState == 4 && xmlHttp.status == 200) {
            callback(xmlHttp.responseText, pinUrl);
        }
    }
    xmlHttp.open("GET", theUrl, true); // true for asynchronous 
    xmlHttp.send(null);
}

function placeMarkers(inputData, pinUrl) {
    console.log('Entered markers function,preparing data');
    var parsedData = JSON.parse(inputData);

    window.gMarkerData = [];
    for (var indexer = 0; indexer < parsedData.length; indexer++) {
        gMarkerData[indexer] = { latLng: { lat: parsedData[indexer].Latitude, lng: parsedData[indexer].Longitude }, title: parsedData[indexer].Name, content: parsedData[indexer].Content, pin: pinUrl }
    }

    var js_file = document.createElement('script');
    js_file.type = 'text/javascript';
    js_file.src = 'https://maps.googleapis.com/maps/api/js?callback=initMapClinic&key=' + googleMapsKey;
    document.getElementsByTagName('head')[0].appendChild(js_file);
}

const addGoogleMapClinic = function (mapSelector) {
    document.addEventListener('DOMContentLoaded', function () {
        var mapElement = document.querySelector(mapSelector);
        if (mapElement) {
            window.gMapElement = mapElement;
            var url = gMapElement.getAttribute("data-url");
            var pin = gMapElement.getAttribute("data-pin");
            httpGetAsync(pin, url, placeMarkers);
        }

    });
}
export default addGoogleMapClinic;
